import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFromMS',
  standalone: true,
})
export class TimeFromMSPipe implements PipeTransform {
  transform(milliseconds: number): string {
    const date = new Date(milliseconds);
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    const seconds = date.getUTCSeconds().toString().padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  }
}
